import { put, takeEvery } from "@redux-saga/core/effects";
import AxiosCustom from "common/components/apiConfig";
import { handleNotificationAlertCatch } from "common/method/handleNotificationAlert";

export const actionTypes = {
	insertTicket: "[insertTicket] Action",
	insertTicketEMPTY: "[insertTicketEMPTY] Action",
	insertTicketLoad: "[insertTicketLoad] Action",
	insertTicketAsync: "[insertTicketAsync] Action",
};

const initialState = {
	data: [],
	loading: false,
};

export const insert_ticket_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.insertTicket:
			return {
				...state,
				data: payload ? payload : [],
			};case actionTypes.insertTicketEMPTY:
			return {
				...state,
				data: [],
			};

		case actionTypes.insertTicketLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({ type: actionTypes.insertTicketLoad, payload: true });
	let config = {
		url: "insert_request",
	};

	let data = {
		table: "contactus",
		method_type: "insert",
		data: payload?.data ? payload?.data : {},
		sort_by: {},
	};

	try {
		let res = yield AxiosCustom(config, data);

		yield put({
			type: actionTypes.insertTicket,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({ type: actionTypes.insertTicketLoad, payload: false });
	}
}

export function* insertTicket() {
	yield takeEvery(actionTypes.insertTicketAsync, handleWorker);
}
